<template>
    <div class="esign-settings">
        <settings-template
            :menuItems="menuItems"
            backUrl="/settings/externals"
            :isCustomMenu="true"
        ></settings-template>
    </div>
</template>

<script>
import SettingsTemplate from 'vcomponents/settings/SettingsTemplate.vue';

export default {
    data() {
        return {
            menuItems: [
                {
                    label: this.$l10n.__('Service de signature électronique'),
                    routeName: 'settings.esign.providers',
                },
                {
                    label: this.$l10n.__('Préférences signature électronique'),
                    action: () => window.YousignPrefs.loadPrefs(),
                    routeName: '',
                },
            ],
        };
    },
    components: {
        SettingsTemplate,
    },
};
</script>
